/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TermsOfServiceLegalbirdOSPageMeta from "./TermsOfServiceLegalbirdOSPageMeta";
import Container from "@/src/components/Container/Container";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import TermsOfServiceLegalbirdOS from "@/src/components/TermsOfService/TermsOfServiceLegalbirdOS/TermsOfServiceLegalbirdOS";

const TermsOfServiceLegalbirdOSPage = () => {
  return (
    <LayoutPublicRoutes>
      <TermsOfServiceLegalbirdOSPageMeta />
      <Container showVerticalPadding={false}>
        <TermsOfServiceLegalbirdOS />
      </Container>
    </LayoutPublicRoutes>
  );
};

export default TermsOfServiceLegalbirdOSPage;
